export default "__VITE_ASSET__CcZGxBss__"